export const CnhDigitalIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  strokeWidth = 1.5,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <path d="M15.3333 10.6667H16.6667M16 19.3333V19.34M13.3333 10H18.6667C19.403 10 20 10.597 20 11.3333V20.6667C20 21.403 19.403 22 18.6667 22H13.3333C12.597 22 12 21.403 12 20.6667V11.3333C12 10.597 12.597 10 13.3333 10Z" stroke={strokeColor} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
